var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('ManagingSection',[_c('ManagingBox',{attrs:{"no-header":true,"no-padding":true}},[_c('Chart',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }